import { useEffect, useRef, useState } from 'react'

import { HUBSPOT_FORMS, HubSpotFormId } from 'Constants/HubSpot'

type Props = {
  formId: HubSpotFormId
  onFormSubmitted?: () => void
}

const initializedForms = new Set<string>()

function useHubSpotFormLoader({ formId, onFormSubmitted }: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const formData = HUBSPOT_FORMS[formId]
    if (!formData || !ref.current) return

    const domId = ref.current.id || `hubspot-form-${formId}`
    ref.current.id = domId

    const container = ref.current

    if (initializedForms.has(domId)) {
      setLoading(false)
      return
    }

    const createForm = () => {
      if ((window as any).hbspt) {
        ;(window as any).hbspt.forms.create({
          ...formData.createOptions,
          target: `#${domId}`,
          onFormReady: () => {
            setLoading(false)
            initializedForms.add(domId)
          },
          onFormSubmitted: () => {
            onFormSubmitted?.()
          },
        })
      }
    }

    const scriptUrl = formData.scriptUrl
    const existingScript = document.querySelector(`script[src="${scriptUrl}"]`)

    if (existingScript) {
      createForm()
    } else {
      const script = document.createElement('script')
      script.src = scriptUrl
      script.async = true
      script.onload = createForm
      document.body.appendChild(script)
    }

    return () => {
      container.innerHTML = ''
      initializedForms.delete(domId)
    }
  }, [formId, onFormSubmitted])

  return { ref, loading }
}
export default useHubSpotFormLoader
